import React from "react";
import StudentsTable from "../components/studentslist/StudentsTable";
export default function RoomTable() {
    return <StudentsTable mode={1}/>;
}
